export default __webpack_public_path__ + "static/media/p8.125742c7.PNG";